import * as React from 'react'
import textParser from 'services/textParser';
import { useTemperatureUnitContext } from 'context/TemperatureUnitContext';

export const TextParser = ({ text }: { text: string }) => {
    const [units] = useTemperatureUnitContext()
    return (
        <span>{textParser({text,units})}</span>
    )
}